<template>
  <section class="page-content product-output-list">
    <SearchFilteredProducts />
  </section>
</template>

<script>
import SearchFilteredProducts from "@/base/core/components/search/SearchFilteredProducts";
export default {
  name: "SearchPageContent",
  components: {
    SearchFilteredProducts,
  },
};
</script>

<style lang="scss" scoped></style>
